import * as Yup from "yup";

export const VerificationCodeSchema = Yup.object().shape({
  code: Yup.string()
    .required("Please enter your confirmation code")
    .matches(/^[0-9]+$/, "Must be only digits")
    .test("len", "Must be exactly 6 digits", (val) => val?.length === 6),
});
